import * as React from 'react'
import AppFeatureEditor from '../AppFeatureEditor'
import {Feature} from '../../../core/models'

class StreetAreaEditor extends AppFeatureEditor {
  protected getGeometryEditor(feature: Feature): JSX.Element {
    return <div></div>
  }
}

export default StreetAreaEditor
